import React from 'react';
import './App.css';
import LottoGenerator from './components/LottoGenerator';
import RecentResults from './components/RecentResults';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>로또 번호 생성기</h1>
      </header>
      <main>
        <LottoGenerator />
        <RecentResults />
      </main>
      <footer>
        <p>Powered by Gemini CLI</p>
      </footer>
    </div>
  );
}

export default App;

